var React = require('react');

function Lock (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11 6.27815V4.99999C11 2.24317 8.75681 0 5.99998 0C3.24316 0 0.999992 2.24317 0.999992 4.99999V6.27815C0.405093 6.62502 0 7.2629 0 8V14C0 15.103 0.896958 16 1.99998 16H9.99998C11.103 16 12 15.103 12 14V8C12 7.26287 11.5949 6.62499 11 6.27815ZM5.99998 1.99998C7.65428 1.99998 8.99999 3.34567 8.99999 4.99999V5.99998H2.99998V4.99999C2.99998 3.3457 4.34569 1.99998 5.99998 1.99998ZM6.99998 11.6107V13H4.99999V11.6107C4.69517 11.3362 4.5 10.9425 4.5 10.5C4.5 9.67155 5.17155 8.99999 5.99998 8.99999C6.82842 8.99999 7.49997 9.67155 7.49997 10.5C7.49997 10.9425 7.3048 11.3362 6.99998 11.6107Z","fill":"#7D8387"}));
}

Lock.defaultProps = {"width":"12","height":"16","viewBox":"0 0 12 16","fill":"none"};

module.exports = Lock;

Lock.default = Lock;
